// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__9lA6E","loading":"Detail_loading__+VpGp","character":"Detail_character__KYbDP"};